/**
 * Analytics API Service
 *
 * Client-side API functions for analytics endpoints
 */

import api from './api';

/**
 * Build query params from filter object
 */
const buildParams = (filters = {}) => {
  const params = {};

  if (filters.range) {
    params.range = filters.range;
  }

  if (filters.range === 'custom') {
    if (filters.startDate) {
      params.startDate = filters.startDate instanceof Date
        ? filters.startDate.toISOString()
        : filters.startDate;
    }
    if (filters.endDate) {
      params.endDate = filters.endDate instanceof Date
        ? filters.endDate.toISOString()
        : filters.endDate;
    }
  }

  return params;
};

/**
 * Analytics API methods
 */
export const analyticsAPI = {
  /**
   * Get overview KPIs for dashboard summary cards
   * @param {object} filters - { range, startDate, endDate }
   */
  getOverview: async (filters = {}) => {
    const response = await api.get('/analytics/overview', {
      params: buildParams(filters)
    });
    return response.data;
  },

  /**
   * Get hiring funnel metrics
   * @param {object} filters - { range, startDate, endDate }
   */
  getFunnel: async (filters = {}) => {
    const response = await api.get('/analytics/funnel', {
      params: buildParams(filters)
    });
    return response.data;
  },

  /**
   * Get time-to-fill and stage duration metrics
   * @param {object} filters - { range, startDate, endDate }
   */
  getTimeMetrics: async (filters = {}) => {
    const response = await api.get('/analytics/time-metrics', {
      params: buildParams(filters)
    });
    return response.data;
  },

  /**
   * Get source effectiveness metrics
   * @param {object} filters - { range, startDate, endDate }
   */
  getSources: async (filters = {}) => {
    const response = await api.get('/analytics/sources', {
      params: buildParams(filters)
    });
    return response.data;
  }
};

export default analyticsAPI;
